export const CasinoCommandNames = {
  GET_OPTIONS: 'getOptions',
  GET_GAMES: 'getGames',
  GET_PROMOTED_GAMES: 'getPromotedGames',
  GET_TOURNAMENT_GAMES: 'getTournamentGames',
  GET_GAME_TOURNAMENTS: 'getTournaments',
  GET_GROUPED_PROVIDER_OPTIONS: 'getGroupedProviderOptions',
  GET_DECENTRALIZED_GAMES: 'games',
  GET_DECENTRALIZED_GAME: 'game',
  GET_DECENTRALIZED_CATEGORIES: 'categories',
  GET_JACKPOT_GAMES: 'getJackpotGames'
};
